import { BecomeContentCreatorContainer } from "modules/Setting";



type Props = {}

const BecomeContentCreator = (props: Props) => {
    return (
        <BecomeContentCreatorContainer
        />
    )
}

export default BecomeContentCreator;